import gudangService from '../../services/gudangService/service';
import gudangModel from '../../models/gudangModel/model';

export default {
    async fetchGudang (search, page, limit, company_id) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const { data, headers } = await gudangService.getGudang(sanitizedSearch, page, limit, company_id);
            return {
                data: data.map(gudang => new gudangModel(gudang)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching gudang:', error);
            throw error;
        }
    },
    async totalAllGudang (search, company_id) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const response = await gudangService.totalAllGudang(sanitizedSearch, company_id);
            return response;
        } catch (error) {
            console.error('Error fetching gudang:', error);
            throw error;
        }
    },
    async addGudang (data) {
        try {
            const response = await gudangService.addGudang(data);
            return response;
        } catch (error) {
            console.error('Error adding gudang:', error);
            throw error;
        }
    },
    async updateGudang (data) {
        try {
            const response = await gudangService.updateGudang(data);
            return response;
        } catch (error) {
            console.error('Error updating gudang:', error);
            throw error;
        }
    },
    async deleteGudang (id, dc) {
        try {
            const response = await gudangService.deleteGudang(id, dc);
            return response;
        } catch (error) {
            console.error('Error deleting gudang:', error);
            throw error;
        }
    }
}